export const pages = (navigateTo, routes, cred) => {
  const data = [
    { label: "Transactions", action: () => navigateTo(routes.base) },
  ];

  if (cred.grant_type === "system_admin")
    return [
      ...data,
      { label: "Users", action: () => navigateTo(routes.users) },
    ];

  return data;
};

export const usersMetadata = (filterUserList) => [
  { label: "All Users", action: filterUserList(null) },
  { label: "Active", action: filterUserList(true) },
  { label: "Inactive", action: filterUserList(false) },
];

export const analyticsTabMetadata = () => [
  { label: "Daily", action: () => {} },
  { label: "Weekly", action: () => {} },
  { label: "Monthly", action: () => {} },
];
